let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("40mPQ")).then(() => parcelRequire('6Me6l'));